var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3048 1.4665C13.7952 1.69227 13.2546 1.84046 12.7011 1.90615C13.2776 1.5606 13.7203 1.0134 13.9288 0.361422C13.3807 0.686659 12.7811 0.915809 12.1558 1.03897C11.6464 0.496347 10.9208 0.157227 10.1177 0.157227C8.57567 0.157227 7.32546 1.40738 7.32546 2.94929C7.32546 3.16816 7.35018 3.38124 7.39776 3.58564C5.07724 3.46917 3.01987 2.3576 1.64271 0.668326C1.40242 1.0807 1.26473 1.56038 1.26473 2.07202C1.26473 3.04073 1.7577 3.89531 2.50686 4.39604C2.06346 4.38216 1.62982 4.2624 1.24214 4.04677C1.24198 4.05847 1.24198 4.07016 1.24198 4.08191C1.24198 5.43472 2.20442 6.56325 3.48169 6.81975C3.07053 6.93157 2.63925 6.94794 2.2208 6.8676C2.57608 7.97688 3.60726 8.78409 4.82903 8.80668C3.87344 9.55552 2.66948 10.0019 1.36138 10.0019C1.13597 10.0019 0.913755 9.98868 0.695312 9.9629C1.93096 10.7551 3.3986 11.2174 4.97538 11.2174C10.1112 11.2174 12.9196 6.96276 12.9196 3.2731C12.9196 3.152 12.9169 3.03159 12.9115 2.91187C13.4581 2.51671 13.9299 2.02726 14.3048 1.4665Z",
    fill: "url(#paint0_linear_4817_153837)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4817_153837",
    x1: 7.50005,
    y1: -1.8336,
    x2: 7.50005,
    y2: 12.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f1d3eff57fdded9b62194d36e221f9cd.svg";
export { ForwardRef as ReactComponent };